/* @flow */

import { getMembershipTimezone } from '@e180/domain/lib/membership/util';

import useMembership from './useMembership';

export default function useMembershipTimezone(): ?string {
  const membership = useMembership();

  if (!membership) {
    return null;
  }

  return getMembershipTimezone(membership);
}
